import React from "react";
import { useTranslation } from "react-i18next";

interface ChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

const ChatModal: React.FC<ChatModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 h-[40vh] bg-gray-800 border-t border-gray-700 z-50">
      <div className="flex items-center justify-between px-3 py-2">
        <h3 className="text-xs font-medium text-gray-300">
          {title || t("chat")}
        </h3>
        <button
          onClick={onClose}
          className="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700 rounded transition-colors text-xs"
        >
          ✕
        </button>
      </div>
      <div className="h-[calc(100%-2rem)] relative">
        {children}
      </div>
    </div>
  );
};

export default ChatModal;